<app-tb-accordion
    *transloco="let tAdvancedOptions; read: 'advanced_options'"
    [title]="tAdvancedOptions('statuses')"
    [description]="tAdvancedOptions('options_description', { configuration_item: 'statuses' })"
    [expanded]="true"
    [background]="true"
    [settingsShow]="true"
    [settingsDisabled]="!activeAvailableTabs().length"
    [messageOnDisabled]="tAdvancedOptions('all_status_inactive')"
    (callAdvanced)="openStatusSettings()"
>
    <div class="w-full flex bg-neutral2 px-4 pb-4">
        <div class="flex flex-col w-full gap-5 p-4 rounded-lg bg-white">
            @for (schema of availableTabs(); track schema.id) {
                @if (statusBySchema()[schema.id]; as status) {
                    <div class="flex flex-row">
                        <div class="flex-1 body-2">
                            <div class="flex items-center gap-1">
                                <app-tb-icon [icon]="schema.icon!"></app-tb-icon>
                                <span>
                                    {{ schema.name }}
                                </span>
                            </div>
                        </div>
                        <div class="flex-1">
                            @if (inactiveFieldsObject()[status.guid]) {
                                {{
                                    tAdvancedOptions('status_inactive_in_sot', { sot: schema.name })
                                }}
                            } @else {
                                <app-status-section-content
                                    [field]="status"
                                ></app-status-section-content>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</app-tb-accordion>
